import { Banner, Box, InlineStack, Text } from '@shopify/polaris'

import { InternalLink } from '../common/helpers'
import { SubscriptionContract } from '../common/subscription-models'
import * as urls from '../common/urls'

export const ProcessingWorkflowsCard = ({ sub }: { sub: SubscriptionContract }) => {
  return (
    <Box paddingBlockEnd="200">
      <Banner tone="warning">
        <InlineStack align="space-between" gap="200">
          <Text as="p">Processing workflows...</Text>
          <InternalLink url={urls.workflowLogsUrl({ subscription_id: sub.rest_id })}>
            View workflow logs
          </InternalLink>
        </InlineStack>
      </Banner>
    </Box>
  )
}
